(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5063,5275],{

/***/ 99170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CarouselWidget": function() { return /* reexport */ Carousel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/utils.tsx
var utils = __webpack_require__(58619);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/Chevrons/index.tsx





var ChevronType1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1087).then(__webpack_require__.bind(__webpack_require__, 51087)).then(function(mod) {
        return mod.ChevronType1;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51087)
            ];
        }
    }
});
var ChevronType2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8690).then(__webpack_require__.bind(__webpack_require__, 48690)).then(function(mod) {
        return mod.ChevronType2;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48690)
            ];
        }
    }
});
var ChevronType3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5835).then(__webpack_require__.bind(__webpack_require__, 95835)).then(function(mod) {
        return mod.ChevronType3;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95835)
            ];
        }
    }
});
var ChevronType4 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2883).then(__webpack_require__.bind(__webpack_require__, 12883)).then(function(mod) {
        return mod.ChevronType4;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12883)
            ];
        }
    }
});
function Chevrons(props) {
    var _RenderChevrons = function _RenderChevrons() {
        switch(type){
            case 0:
                return ChevronType1;
            case 1:
                return ChevronType2;
            case 2:
                return ChevronType3;
            case 3:
                return ChevronType4;
            default:
                return ChevronType1;
        }
    };
    var ref, ref1, ref2;
    var images = props.images, videoConfig = props.videoConfig;
    var ref3 = (0,react.useState)(videoConfig), videoChevronConfig = ref3[0], setVideoChevronConfig = ref3[1];
    var ref4 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref4.widgetContextState.globalStyle;
    (0,react.useEffect)(function() {
        setVideoChevronConfig(videoConfig);
    }, [
        videoConfig
    ]);
    if (!(images === null || images === void 0 ? void 0 : images.length)) {
        return null;
    }
    var isDesktop = props.isDesktop, widgetOptions = props.widgetOptions;
    var showChevrons = (images === null || images === void 0 ? void 0 : images.length) > 1;
    var showArrows = (images === null || images === void 0 ? void 0 : images.length) > 1 && (isDesktop || !isDesktop && (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.chevrons) === null || ref === void 0 ? void 0 : ref.showArrowInMobile));
    var chevronAnimationTiming = ((videoChevronConfig === null || videoChevronConfig === void 0 ? void 0 : videoChevronConfig.isVideo) ? (videoChevronConfig === null || videoChevronConfig === void 0 ? void 0 : videoChevronConfig.duration) * 1000 : widgetOptions.autoPlay ? (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.autoplaySpeed) * 1000 : widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.autoplaySpeed) + "ms";
    var type = globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.chevrons) === null || ref1 === void 0 ? void 0 : ref1.selected;
    var arrowPosition = globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.chevrons) === null || ref2 === void 0 ? void 0 : ref2.arrowPosition;
    var _autoPlay;
    var isAutoPlayOn = (_autoPlay = widgetOptions.autoPlay) !== null && _autoPlay !== void 0 ? _autoPlay : true;
    var _PushPropsHOC = function(Component) {
        var ref;
        var commonProps = (0,_object_spread/* default */.Z)({
            showArrows: showArrows,
            chevronAnimationTiming: chevronAnimationTiming,
            showChevrons: showChevrons,
            isAutoPlayOn: isAutoPlayOn,
            arrowPosition: arrowPosition,
            iconShape: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.chevrons) === null || ref === void 0 ? void 0 : ref.arrowShape) || "circular"
        }, props);
        var comp = function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, commonProps));
        };
        return comp;
    };
    var ChevronElement = _PushPropsHOC(_RenderChevrons());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10 tw-flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronElement, {})
    });
}

// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(62946);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/CreateHTML.tsx + 6 modules
var CreateHTML = __webpack_require__(14564);
// EXTERNAL MODULE: ./src/constants/widgets.ts
var constants_widgets = __webpack_require__(42381);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(68037);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/hook/CarouselVideoHook.tsx

var useCarouselVideoConfig = function(sliderRef, widgetOptions) {
    var resumeSlider = function resumeSlider() {
        setTimeout(function() {
            var _current, ref;
            (ref = (_current = sliderRef.current).slickPlay) === null || ref === void 0 ? void 0 : ref.call(_current);
        }, 100);
    };
    var removeTimeoutAndConfig = function removeTimeoutAndConfig() {
        var ref;
        setVideoConfig({
            duration: widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.autoplaySpeed,
            isVideo: false
        });
        if ((ref = videoTimeoutRef.current) === null || ref === void 0 ? void 0 : ref.length) {
            clearTimeout(videoTimeoutRef.current[0]);
            resumeSlider();
        }
    };
    var videoTimeoutRef = (0,react.useRef)([]);
    var ref = (0,react.useState)({
        isVideo: false,
        duration: 0
    }), videoConfig = ref[0], setVideoConfig = ref[1];
    var handleVideoDuration = function(val, isVideoVisible) {
        var ref;
        if (val && (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.autoPlay) && isVideoVisible) {
            var _current, ref1;
            (ref1 = (_current = sliderRef.current).slickPause) === null || ref1 === void 0 ? void 0 : ref1.call(_current);
            setVideoConfig({
                duration: val,
                isVideo: true
            });
            var timeoutId = setTimeout(function() {
                var ref;
                (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext();
                removeTimeoutAndConfig();
                resumeSlider();
            }, val * 1000);
            videoTimeoutRef.current.push(timeoutId);
        } else if (!isVideoVisible && ((ref = videoTimeoutRef.current) === null || ref === void 0 ? void 0 : ref.length) > 1) {
            var ref2;
            clearTimeout(videoTimeoutRef.current[0]);
            videoTimeoutRef.current = (ref2 = videoTimeoutRef.current) === null || ref2 === void 0 ? void 0 : ref2.slice(1);
        }
    };
    return {
        videoConfig: videoConfig,
        handleVideoDuration: handleVideoDuration
    };
};
/* harmony default export */ var CarouselVideoHook = (useCarouselVideoConfig);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(98388);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(46976);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(89429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentButtonAnimationStyle.module.scss
var ContentButtonAnimationStyle_module = __webpack_require__(36508);
var ContentButtonAnimationStyle_module_default = /*#__PURE__*/__webpack_require__.n(ContentButtonAnimationStyle_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(93080);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var common = __webpack_require__(20901);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(91850);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/RichTextImage/component/TextEditor.tsx
var TextEditor = __webpack_require__(74232);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CommonLinkWrapper/index.tsx
var CommonLinkWrapper = __webpack_require__(86353);
// EXTERNAL MODULE: ./src/utils/checkIsAudioPresentInVideo.ts
var checkIsAudioPresentInVideo = __webpack_require__(5271);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/BannerItem/BannerItem.tsx


















function BannerItem(props) {
    var handleSoundClick = function handleSoundClick() {
        setIsMuted(function(prev) {
            return !prev;
        });
    };
    var _RenderBannerImageComponent = function _RenderBannerImageComponent(param) {
        var imageUrl = param.imageUrl, bannerMetaText = param.bannerMetaText;
        var _ImageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: imageUrl,
            alt: bannerMetaText,
            priority: true,
            layout: "fill",
            quality: isMobile ? 80 : 100,
            className: classnames_default()("tw-w-full tw-object-cover", (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.isBannerFullWidth) !== false && "removeGlobalOverride")
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-relative",
            style: imageWrapperComponentStyles,
            children: _ImageComponent
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var // primary props
    image = props.image, index = props.index, isNewCarousel = props.isNewCarousel, widgetOptions = props.widgetOptions, isMobile = props.isMobile, _isCurrentSlideActive = props.isCurrentSlideActive, isCurrentSlideActive = _isCurrentSlideActive === void 0 ? false : _isCurrentSlideActive, // secondary props
    videoElementRefs = props.videoElementRefs, handleVideoDuration = props.handleVideoDuration, setVideoElementRefs = props.setVideoElementRefs, globalStyle = props.globalStyle, shouldShiftTextContainer = props.shouldShiftTextContainer, getAdjustedShiftFromTop = props.getAdjustedShiftFromTop, _imageWrapperComponentStyles = props.imageWrapperComponentStyles, imageWrapperComponentStyles = _imageWrapperComponentStyles === void 0 ? {} : _imageWrapperComponentStyles;
    var ref25 = (0,react.useState)(true), isMuted = ref25[0], setIsMuted = ref25[1];
    var isDesktop = !isMobile;
    var imageUrl = image.image_url || image.src;
    var oldRedirectLink = !isNewCarousel ? (ref = widgetOptions.links) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.href : "";
    var ref26 = (0,utils/* useGetAlignments */.pQ)({
        isDesktop: !isMobile,
        widgetOptions: widgetOptions
    }), getButtonAlignment = ref26.getButtonAlignment, getContentPosition = ref26.getContentPosition;
    var bannerAnimationClass = utils/* getBannerAnimationClass */.X1 === null || utils/* getBannerAnimationClass */.X1 === void 0 ? void 0 : (0,utils/* getBannerAnimationClass */.X1)({
        widgetOptions: widgetOptions,
        isCurrentSlideActive: isCurrentSlideActive
    });
    var isVideo = image.is_video;
    var showMuteToggler = isVideo && (0,checkIsAudioPresentInVideo/* checkIsAudioPresentInVideo */.J)({
        videoRef: videoElementRefs === null || videoElementRefs === void 0 ? void 0 : videoElementRefs[index],
        defaultAudioStatus: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("tw-relative tw-bg-opacity-".concat((image === null || image === void 0 ? void 0 : (ref2 = image.textContent) === null || ref2 === void 0 ? void 0 : ref2.overlayOpacity) || 20), ((image === null || image === void 0 ? void 0 : (ref3 = image.actions) === null || ref3 === void 0 ? void 0 : ref3.handler) || oldRedirectLink) && "tw-cursor-pointer", !isNewCarousel && "tw-h-full tw-w-full"),
                onClick: function() {
                    var ref;
                    if (image === null || image === void 0 ? void 0 : (ref = image.actions) === null || ref === void 0 ? void 0 : ref.handler) {
                        (0,btnUtils/* btnActionHandler */.c)(image === null || image === void 0 ? void 0 : image.actions);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* WithLink */.oF, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        className: "tw-h-full tw-w-full",
                        redirectLink: oldRedirectLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,bundle_mjs/* twMerge */.m6)("image-container", bannerAnimationClass),
                            children: imageUrl ? isVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* RenderMediaComponent */.MB, {
                                mediaData: {
                                    type: "video",
                                    autoplay: true,
                                    hideControls: true,
                                    isVideoMuted: isMuted,
                                    content: [
                                        {
                                            url: imageUrl
                                        }, 
                                    ],
                                    showMuteUnmuteOption: true,
                                    getVideoDuration: function(val, isVisble) {
                                        return handleVideoDuration === null || handleVideoDuration === void 0 ? void 0 : handleVideoDuration(val, isVisble);
                                    },
                                    setMediaComponentRef: function(node) {
                                        if ((videoElementRefs === null || videoElementRefs === void 0 ? void 0 : videoElementRefs[index]) || !node) return;
                                        if (index === 0) node.currentTime = 4;
                                        setVideoElementRefs === null || setVideoElementRefs === void 0 ? void 0 : setVideoElementRefs(function(els) {
                                            var newEls = (0,_to_consumable_array/* default */.Z)(els || []);
                                            newEls[index] = node;
                                            return newEls;
                                        });
                                    }
                                }
                            }) : _RenderBannerImageComponent({
                                imageUrl: imageUrl,
                                bannerMetaText: (image === null || image === void 0 ? void 0 : (ref4 = image.textContent) === null || ref4 === void 0 ? void 0 : ref4.bannerMetaText) || ""
                            }) : _RenderBannerImageComponent({
                                imageUrl: "https://cdn.dotpe.in/longtail/themes/8073865/BRuFN2JQ.webp",
                                bannerMetaText: (image === null || image === void 0 ? void 0 : (ref5 = image.textContent) === null || ref5 === void 0 ? void 0 : ref5.bannerMetaText) || ""
                            })
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[1]",
                        style: {
                            background: "rgba(0,0,0, ".concat((image === null || image === void 0 ? void 0 : (ref6 = image.textContent) === null || ref6 === void 0 ? void 0 : ref6.overlayOpacity) / 100, ")"),
                            borderRadius: (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.isBannerFullWidth) === false ? (ref10 = globalStyle === null || globalStyle === void 0 ? void 0 : (ref7 = globalStyle.imageCards) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.style) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.borderRadius) === null || ref9 === void 0 ? void 0 : ref9.split(" !important")) === null || ref10 === void 0 ? void 0 : ref10[0] : ""
                        }
                    }),
                    ((image === null || image === void 0 ? void 0 : (ref11 = image.textContent) === null || ref11 === void 0 ? void 0 : ref11.isShow) || ((ref12 = image.buttons) === null || ref12 === void 0 ? void 0 : ref12.find(function(btn) {
                        return btn.isShow;
                    }))) && isCurrentSlideActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: "100%",
                            justifyContent: !isMobile ? widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.contentPositionDesktop : "center",
                            top: "calc(50% + ".concat(shouldShiftTextContainer ? getAdjustedShiftFromTop === null || getAdjustedShiftFromTop === void 0 ? void 0 : getAdjustedShiftFromTop() : 0, "px)")
                        },
                        className: "tw-absolute tw-top-1/2 tw-z-30 tw-flex tw-min-w-[30%] tw--translate-y-1/2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,bundle_mjs/* twMerge */.m6)(" ".concat(!isMobile ? "tw-mx-[80px] tw-p-[52px]" : "tw-px-[24px] tw-py-[40px]"), isCurrentSlideActive && (ContentAnimationStyles_module_default())[(ref13 = widgetOptions.contentAnimationConfig) === null || ref13 === void 0 ? void 0 : ref13.className]),
                            style: {
                                width: !isMobile ? "".concat(image === null || image === void 0 ? void 0 : (ref14 = image.textContent) === null || ref14 === void 0 ? void 0 : ref14.width, "%") || 0 : "90%",
                                color: (image === null || image === void 0 ? void 0 : (ref15 = image.textContent) === null || ref15 === void 0 ? void 0 : ref15.textColor) || "#ffffff",
                                background: isCurrentSlideActive ? image === null || image === void 0 ? void 0 : (ref16 = image.textContent) === null || ref16 === void 0 ? void 0 : ref16.backgroundColor : "transparent"
                            },
                            children: [
                                (image === null || image === void 0 ? void 0 : (ref17 = image.textContent) === null || ref17 === void 0 ? void 0 : ref17.isShow) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,bundle_mjs/* twMerge */.m6)("tw-z-[999]"),
                                    children: [
                                        (image === null || image === void 0 ? void 0 : (ref18 = image.textContent) === null || ref18 === void 0 ? void 0 : ref18.headline) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor/* EditableText */.s, {
                                            style: {
                                                textAlign: getContentPosition(),
                                                fontSize: isDesktop ? 40 : 28
                                            },
                                            content: image === null || image === void 0 ? void 0 : (ref19 = image.textContent) === null || ref19 === void 0 ? void 0 : ref19.headline,
                                            className: "tw-my-0 tw-font-light tw-text-".concat(getContentPosition(), " tw-text-[28px] md:tw-text-[40px] ")
                                        }) : null,
                                        (image === null || image === void 0 ? void 0 : (ref20 = image.textContent) === null || ref20 === void 0 ? void 0 : ref20.description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor/* EditableText */.s, {
                                            content: image === null || image === void 0 ? void 0 : (ref21 = image.textContent) === null || ref21 === void 0 ? void 0 : ref21.description,
                                            style: {
                                                textAlign: getContentPosition()
                                            },
                                            className: "tw-mb-0 tw-mt-16 tw-text-16 tw-font-light tw-leading-[23px] tw-text-".concat(getContentPosition())
                                        }) : null
                                    ]
                                }),
                                (image === null || image === void 0 ? void 0 : (ref22 = image.buttons) === null || ref22 === void 0 ? void 0 : ref22.length) && isCurrentSlideActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,bundle_mjs/* twMerge */.m6)("tw-mt-[36px] tw-flex tw-w-full tw-flex-col md:tw-flex-row ".concat(getButtonAlignment === null || getButtonAlignment === void 0 ? void 0 : getButtonAlignment("flex")), isCurrentSlideActive && (ContentButtonAnimationStyle_module_default())[(ref23 = widgetOptions.contentAnimationConfig) === null || ref23 === void 0 ? void 0 : ref23.className]),
                                    style: {
                                        flexDirection: isDesktop ? "row" : "column"
                                    },
                                    children: (ref24 = image.buttons) === null || ref24 === void 0 ? void 0 : ref24.map(function(buttonData, btnIndex) {
                                        var ref, ref1;
                                        var buttonVariant = (0,utils/* getButtonVariantsData */.Tk)(buttonData);
                                        var selectedButtonType = buttonVariant[buttonData.type];
                                        var link = buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.actions) === null || ref === void 0 ? void 0 : ref.handler;
                                        return buttonData.isShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
                                            link: link,
                                            disableLinkOnNewTab: buttonData === null || buttonData === void 0 ? void 0 : (ref1 = buttonData.actions) === null || ref1 === void 0 ? void 0 : ref1.newTab,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                size: buttonConstant/* BUTTON_SIZE_TYPE.LARGE */.n6.LARGE,
                                                btnType: buttonData.type,
                                                buttonData: buttonData,
                                                selectedButtonData: selectedButtonType,
                                                variant: selectedButtonType.variant,
                                                textualAlignment: getContentPosition(),
                                                onClick: function(e) {
                                                    e.stopPropagation();
                                                    (0,btnUtils/* btnActionHandler */.c)(buttonData === null || buttonData === void 0 ? void 0 : buttonData.actions, function() {});
                                                },
                                                className: (0,bundle_mjs/* twMerge */.m6)("tw-rounded-none !tw-text-[16px] !tw-font-normal\n                 [&>p]:!tw-text-ellipsis [&>p]:!tw-whitespace-nowrap\n                  ".concat(btnIndex ? isDesktop ? " !tw-ml-[25px] sm:!tw-ml-0 sm:!tw-mt-[25px] " : " !tw-mt-[14px] sm:!tw-ml-0 sm:!tw-mt-[14px] " : "", "\n                  ").concat(!isDesktop ? " !tw-w-[100%]" : "", "\n                  ")),
                                                children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                                            }, btnIndex)
                                        }) : null;
                                    })
                                }) : null
                            ]
                        })
                    })
                ]
            }),
            showMuteToggler && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: handleSoundClick,
                className: classnames_default()("tw-pointer wb-sprite tw-absolute !tw-z-50 ".concat(isMobile ? "tw-bottom-[10px] tw-right-[10px]" : "tw-bottom-[16px] tw-right-[16px]"), isMuted ? "unmute-lg" : "mute-lg")
            })
        ]
    }, imageUrl);
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/BannerItem/index.ts


;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/components/IntermittentBanner/index.tsx









function IntermittentBanner(props) {
    var ref, ref1, ref2, ref3;
    var widgets = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.jsonWidgetsReducer.widgets;
    });
    var storeData = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var isMobile = (0,useGetDeviceType/* useGetDeviceType */.n)().isMobile;
    var widgetOptions = props.widgetOptions;
    /**  When this intermittent banner is used as loader, nothing can be passed as props, thus this was used
   * The issue if arises in future will be if both Carousel & NewHeroBanner are present in a store together,
   *  */ if (!props.widgetOptions) {
        var ref4;
        widgetOptions = ((ref4 = Object.values(widgets || {}).find(function(widget) {
            return [
                constants_widgets/* OLD_WIDGET_NAMES.CAROUSEL */.mB.CAROUSEL,
                constants_widgets/* ADMIN_WIDGETS_NAMES.HERO_BANNER */.G.HERO_BANNER
            ].includes(widget.name);
        })) === null || ref4 === void 0 ? void 0 : ref4.props) || (0,_object_spread/* default */.Z)({}, utils/* DEFAULT_WIDGET_OPTIONS */.ry);
    }
    var images = (0,utils/* getBannerImages */.YG)({
        props: {
            store: storeData,
            widgetOptions: widgetOptions
        },
        activeWidgetProps: null,
        isDesktop: !isMobile
    });
    var isNewCarousel = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.forNewCarousel;
    var heightFromProps = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions[isMobile ? "heightMobile" : "height"];
    var useOriginalHeight = heightFromProps === "original";
    var height = function() {
        if (useOriginalHeight) {
            return "100vh";
        }
        var heighToSet = "";
        // This removed px unit because we need to calculate aspect ratio by using configured height unit, with fixed width unit
        if (isNewCarousel) {
            var ref;
            heighToSet = (heightFromProps === null || heightFromProps === void 0 ? void 0 : (ref = heightFromProps.includes) === null || ref === void 0 ? void 0 : ref.call(heightFromProps, "px")) ? heightFromProps === null || heightFromProps === void 0 ? void 0 : heightFromProps.split("px")[0] : heightFromProps;
        } else {
            var ref1, ref2;
            heighToSet = (0,utils/* getHeight */.Cr)(widgetOptions, props === null || props === void 0 ? void 0 : (ref1 = props.containerRef) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.clientWidth, isNewCarousel, isMobile);
        }
        return heighToSet;
    }();
    var imageToShow = images[0];
    (0,react.useEffect)(function() {
        if (props.setLoadSlider) {
            var timeoutID = setTimeout(function() {
                props.setLoadSlider(true);
            }, 3100);
            return function() {
                clearTimeout(timeoutID);
            };
        }
    }, []);
    if (!imageToShow) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("tw-relative tw-bg-opacity-20"),
        ref: props.containerRefCallback,
        style: isNewCarousel && (0,_object_spread/* default */.Z)({
            marginTop: (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.marginTop) + props.adjustedMarginByAnnouncement || "0px",
            marginBottom: (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.marginBottom) || "0px"
        }, (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.isBannerFullWidth) === false ? {
            marginLeft: isMobile ? "16px" : "80px",
            marginRight: isMobile ? "16px" : "80px"
        } : {}),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerItem, {
            image: imageToShow,
            isCurrentSlideActive: true,
            isNewCarousel: isNewCarousel,
            widgetOptions: widgetOptions,
            imageWrapperComponentStyles: isNewCarousel && !useOriginalHeight ? {
                aspectRatio: "".concat(utils/* BASE_WIDTH_FOR_ASPECT_RATIO */.yJ[isMobile ? "mobile" : "desktop"], "/").concat(height)
            } : {
                height: height,
                width: (props === null || props === void 0 ? void 0 : (ref = props.containerRef) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth) ? "".concat(props === null || props === void 0 ? void 0 : (ref2 = props.containerRef) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.current) === null || ref3 === void 0 ? void 0 : ref3.clientWidth, "px") : "100vw"
            },
            isMobile: isMobile
        })
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/hook/useGetCarouselRef.ts

function useGetCarouselRef() {
    var ref = (0,react.useState)({
        current: null
    }), sliderRef = ref[0], setSliderRef = ref[1];
    var sliderRefCallback = (0,react.useCallback)(function(node) {
        if (!node) return;
        setSliderRef({
            current: node
        });
    }, []);
    var ref1 = (0,react.useState)({
        current: null
    }), containerRef = ref1[0], setContainerRef = ref1[1];
    var containerRefCallback = (0,react.useCallback)(function(node) {
        if (!node) return;
        setContainerRef({
            current: node
        });
    }, []);
    return {
        sliderRefCallback: sliderRefCallback,
        sliderRef: sliderRef,
        containerRef: containerRef,
        containerRefCallback: containerRefCallback
    };
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/Carousel.tsx
















var Slider = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2083).then(__webpack_require__.bind(__webpack_require__, 22083)).then(function(mod) {
        return mod.ReactSlickCarousel;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22083)
            ];
        }
    },
    ssr: false,
    loading: IntermittentBanner
});
var CarouselWidget = function(props) {
    var adjustDimensions = function adjustDimensions() {
        var ref, ref1;
        // setScreenWidth(getInnerWidth());
        setHeight((0,utils/* getHeight */.Cr)(widgetOptions, (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth, isNewCarousel));
        setAspectRatio((0,utils/* getAspectRatio */.n3)(widgetOptions, (ref1 = containerRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth));
    };
    var getAdjustedShiftFromTop = function getAdjustedShiftFromTop() {
        var bannerContainerBottomPadding = 24;
        return (headerHeight - bannerContainerBottomPadding) / 2;
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = useGetCarouselRef(), sliderRefCallback = ref6.sliderRefCallback, sliderRef = ref6.sliderRef, containerRef = ref6.containerRef, containerRefCallback = ref6.containerRefCallback;
    var ref7 = (0,react.useState)(false), loadSlider = ref7[0], setLoadSlider = ref7[1];
    var ref8 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref8.// hasAdminAccess,
    widgetContextState, activeHeaderData = _widgetContextState.activeHeaderData, widgets = _widgetContextState.widgets, showPreview = _widgetContextState.showPreview, globalStyle = _widgetContextState.globalStyle, isBuilder = _widgetContextState.isBuilder, previewDevice = _widgetContextState.previewDevice;
    var headerId = (0,redux/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2, ref3;
        return (ref = state.storeReducer.store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.id;
    });
    var isBuilderChevronEnabled = globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.chevrons;
    var activeWidget = widgets[props.id];
    var activeWidgetProps = activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.props;
    var widgetOptions = (0,_object_spread/* default */.Z)({}, utils/* DEFAULT_WIDGET_OPTIONS */.ry, props.widgetOptions, activeWidgetProps || {});
    var ref9 = CarouselVideoHook(sliderRef, widgetOptions), videoConfig = ref9.videoConfig, handleVideoDuration = ref9.handleVideoDuration;
    var globalClass = (activeHeaderData === null || activeHeaderData === void 0 ? void 0 : (ref = activeHeaderData.headerPropsConfig) === null || ref === void 0 ? void 0 : ref.globalClass) || {};
    var isTransparentHeader = (globalClass === null || globalClass === void 0 ? void 0 : (ref1 = globalClass.staticClass) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.base_config) === null || ref2 === void 0 ? void 0 : ref2.defaultFillColorType) === "transparent";
    var firstWidgetId = (ref3 = widgets[CreateHTML/* ROOT_PARENT */.og]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.children) === null || ref4 === void 0 ? void 0 : ref4[0];
    var firstWidget = widgets[firstWidgetId];
    var isBannerFirstWidget = (firstWidget === null || firstWidget === void 0 ? void 0 : firstWidget.name) === constants_widgets/* ADMIN_WIDGETS_NAMES.HERO_BANNER */.G.HERO_BANNER && props.id === firstWidgetId;
    var shouldShiftTextContainer = isTransparentHeader && isBannerFirstWidget;
    var isNewCarousel = props.forNewCarousel || widgetOptions.forNewCarousel;
    var isHeroBannerWidget = [
        constants_widgets/* OLD_WIDGET_NAMES.CAROUSEL */.mB.CAROUSEL,
        constants_widgets/* ADMIN_WIDGETS_NAMES.HERO_BANNER */.G.HERO_BANNER, 
    ].includes(props.type);
    // const [, setScreenWidth] = useState(getInnerWidth());
    var ref10 = (0,useGetDeviceType/* useGetDeviceType */.n)(), isMobileFromServer = ref10.isMobile;
    var isMobile = isBuilder ? previewDevice === "mobile" : isMobileFromServer;
    var ref11 = (0,react.useState)(0), activeSlide2 = ref11[0], setActiveSlide2 = ref11[1];
    var ref12 = (0,react.useState)((0,utils/* getHeight */.Cr)(widgetOptions, "100vw", isNewCarousel)), height = ref12[0], setHeight = ref12[1];
    var ref13 = (0,react.useState)(widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.aspectRatio), setAspectRatio = ref13[1];
    var ref14 = (0,react.useState)(0), headerHeight = ref14[0], setHeaderHeight = ref14[1];
    var ref15 = (0,react.useState)([]), videoElementRefs = ref15[0], setVideoElementRefs = ref15[1];
    var isDesktop = !isMobile;
    var useImageOriginalHeight = ((ref5 = props.widgetOptions) === null || ref5 === void 0 ? void 0 : ref5[!isMobile ? "height" : "heightMobile"]) === "original";
    var adjustedMarginByAnnouncement = (0,utils/* getTopMarginByAnnouncement */.jN)({
        activeHeaderData: activeHeaderData,
        isMobile: isMobile,
        isBannerFirstWidget: isBannerFirstWidget,
        isTransparentHeader: isTransparentHeader
    });
    var bannerContainerStyles = (0,utils/* getBannerContainerStyles */.ik)({
        isNewCarousel: isNewCarousel,
        widgetOptions: widgetOptions,
        containerRef: containerRef,
        useImageOriginalHeight: useImageOriginalHeight,
        height: height,
        isMobile: isMobile,
        adjustedMarginByAnnouncement: adjustedMarginByAnnouncement
    });
    (0,utils/* useWindowResize */.w_)({
        dependencies: [
            showPreview
        ],
        executor: adjustDimensions,
        widgetOptions: widgetOptions,
        props: props
    });
    var ref16 = (0,utils/* useUpgradeEditorBannerSelection */.ej)({
        activeSlide2: activeSlide2,
        setActiveSlide2: setActiveSlide2,
        id: props.id,
        sliderRef: sliderRef,
        widgetOptions: widgetOptions,
        isBuilderChevronEnabled: isBuilderChevronEnabled
    }), handleNextClick = ref16.handleNextClick, handlePrevClick = ref16.handlePrevClick, allSliderSettings = ref16.allSliderSettings;
    (0,react.useEffect)(function() {
        if (headerId) {
            var headerElement = document.getElementById(headerId.toString());
            headerElement && setHeaderHeight(headerElement.clientHeight);
        }
    }, [
        activeHeaderData,
        headerId
    ]);
    var images = (0,utils/* getBannerImages */.YG)({
        props: props,
        activeWidgetProps: activeWidgetProps,
        isDesktop: isDesktop
    });
    (0,react.useEffect)(function() {
        if (loadSlider && videoElementRefs[0] && activeSlide2 === 0 && allSliderSettings.autoplaySpeed) {
            if (allSliderSettings.autoplaySpeed > 4000) {
                var timeoutID = setTimeout(function() {
                    handleNextClick();
                }, allSliderSettings.autoplaySpeed - 4000);
                return function() {
                    clearTimeout(timeoutID);
                };
            } else handleNextClick();
        }
    }, [
        loadSlider,
        videoElementRefs[0]
    ]);
    if (!isBuilder && !loadSlider && isHeroBannerWidget) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntermittentBanner, {
            containerRefCallback: containerRefCallback,
            containerRef: containerRef,
            widgetOptions: widgetOptions,
            setLoadSlider: setLoadSlider
        });
    }
    if (!(images === null || images === void 0 ? void 0 : images.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRefCallback,
        className: "carousel-widget-slider slider-container tw-relative",
        id: "carousel-widget-slider",
        children: [
            isBuilderChevronEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevrons, {
                widgetOptions: widgetOptions,
                isDesktop: isDesktop,
                currentActiveSlideIndex: activeSlide2,
                handlePrevClick: handlePrevClick,
                handleNextClick: handleNextClick,
                images: images,
                videoConfig: videoConfig
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: bannerContainerStyles,
                children: !!images.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, allSliderSettings), {
                    ref: sliderRefCallback,
                    sliderRefCallback: sliderRefCallback,
                    children: images.map(function(image, index) {
                        var isCurrentSlideActive = activeSlide2 === index;
                        var imageWrapperComponentStyles = {
                            height: bannerContainerStyles.height,
                            width: bannerContainerStyles.width
                        };
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerItem, {
                            image: image,
                            isCurrentSlideActive: isCurrentSlideActive,
                            index: index,
                            isNewCarousel: isNewCarousel,
                            widgetOptions: widgetOptions,
                            imageWrapperComponentStyles: imageWrapperComponentStyles,
                            bannerContainerStyles: bannerContainerStyles,
                            isMobile: isMobile,
                            videoElementRefs: videoElementRefs,
                            setVideoElementRefs: setVideoElementRefs,
                            handleVideoDuration: handleVideoDuration,
                            globalStyle: globalStyle,
                            shouldShiftTextContainer: shouldShiftTextContainer,
                            getAdjustedShiftFromTop: getAdjustedShiftFromTop
                        }, index);
                    })
                }))
            })
        ]
    });
};
/* harmony default export */ var Carousel = (CarouselWidget);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/index.ts



/***/ }),

/***/ 74232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ EditableText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_TiptapTextEditor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11293);
/* harmony import */ var _tiptap_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45823);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_ToolbarMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82522);





function EditableText(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? undefined : _maxLength, _disabled = param.disabled, disabled = _disabled === void 0 ? true : _disabled, _className = param.className, className = _className === void 0 ? "" : _className, _style = param.style, style = _style === void 0 ? {} : _style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_TiptapTextEditor__WEBPACK_IMPORTED_MODULE_2__/* .TiptapTextEditor */ .C, {
        content: content,
        // onTextUpdate={({text}) => onChange('subHeading', text)}
        maxLength: maxLength,
        disabled: disabled,
        className: className,
        style: style,
        renderToolbarProps: function(editor) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tiptap_react__WEBPACK_IMPORTED_MODULE_4__/* .BubbleMenu */ .NM, {
                editor: editor,
                tippyOptions: {
                    duration: 100
                },
                shouldShow: function(props) {
                    return props.editor.isFocused;
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "floating-menu",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_ToolbarMenu__WEBPACK_IMPORTED_MODULE_3__/* .ToolbarMenu */ .H, {
                        editor: editor,
                        showFormattors: false
                    })
                })
            });
        }
    });
}


/***/ }),

/***/ 5271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ checkIsAudioPresentInVideo; }
/* harmony export */ });
function checkIsAudioPresentInVideo(param) {
    var videoRef = param.videoRef, _defaultAudioStatus = param.defaultAudioStatus, defaultAudioStatus = _defaultAudioStatus === void 0 ? true : _defaultAudioStatus;
    var ref;
    if (!videoRef) return defaultAudioStatus;
    var hasAudio = videoRef.mozHasAudio || // Firefox
    !!videoRef.webkitAudioDecodedByteCount || // Chrome (some versions)
    !!((ref = videoRef.audioTracks) === null || ref === void 0 ? void 0 : ref.length); // standard (not properly supported in chrome)
    return hasAudio;
}


/***/ }),

/***/ 36508:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"widgetContentFadeInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInWrapper__gzPMJ","fadeIn":"ContentButtonAnimationStyle_fadeIn__Mx5Ue","widgetContentFadeInZoomInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInZoomInWrapper__9exDB","fadeInZoomIn":"ContentButtonAnimationStyle_fadeInZoomIn__FGJ6r","widgetContentMoveDownWrapper":"ContentButtonAnimationStyle_widgetContentMoveDownWrapper__EWZJt","moveDown":"ContentButtonAnimationStyle_moveDown__HotCW","builderSelectorDemo":"ContentButtonAnimationStyle_builderSelectorDemo__P7Dit","demoMoveDown":"ContentButtonAnimationStyle_demoMoveDown__VsgIP","widgetContentMoveUpWrapper":"ContentButtonAnimationStyle_widgetContentMoveUpWrapper__q4jnq","moveUp":"ContentButtonAnimationStyle_moveUp__JqBuF","demoMoveUp":"ContentButtonAnimationStyle_demoMoveUp__f_z3_","widgetContentSlideLeftWrapper":"ContentButtonAnimationStyle_widgetContentSlideLeftWrapper__C_WGJ","moveLeft":"ContentButtonAnimationStyle_moveLeft__wtumW","demoMoveLeft":"ContentButtonAnimationStyle_demoMoveLeft__XAysw","widgetContentSlideRightWrapper":"ContentButtonAnimationStyle_widgetContentSlideRightWrapper__Ael_0","moveRight":"ContentButtonAnimationStyle_moveRight__NWc9p","demoMoveRight":"ContentButtonAnimationStyle_demoMoveRight__kmTdf","imageZoomIn":"ContentButtonAnimationStyle_imageZoomIn__zXH0u","imageZoomOut":"ContentButtonAnimationStyle_imageZoomOut__ywFAu","zoomInOnHover":"ContentButtonAnimationStyle_zoomInOnHover__wpSXv","ambient":"ContentButtonAnimationStyle_ambient__lq2Vz","animationAmbient":"ContentButtonAnimationStyle_animationAmbient__Mp7Dt"};

/***/ })

}]);